import type { DomainManifest } from 'modules/core/lib/manifests/types'
import { useCreateTicket } from 'modules/ticketing/lib/oneHandlers/task/create-ticket'

import { sidebarManifest } from './sidebar'

export const manifest = {
  sidebar: (navigation) => ({
    items: sidebarManifest(navigation),
  }),
  one: {
    createActions: {
      ticket: {
        actionResolver: useCreateTicket,
        policies: [],
        module: 'ai_ticketing',
      },
    },
  },
  activities: {},
} as const satisfies DomainManifest
